module.exports = __webpack_public_path__ + "img/home-bg.accaf09d.png";